function MngStaffPage(props) {
  return (
    <div>
      <h1>스탭 관리</h1>
    </div>
  );
}

export default MngStaffPage;